import Home from '@/pages/Home.vue';
import Chat from '@/pages/Chat.vue';

// import PopupSignIn from '@/pages/PopupSignIn.vue';
import PopupCalendar from '@/pages/PopupCalendar.vue';
import PopupBooking from '@/pages/PopupBooking.vue';
import PopupProofread from '@/pages/PopupProofread.vue';
import PopupAdmin from '@/pages/PopupAdmin.vue';
import PopupSettings from '@/pages/PopupSettings.vue';
import PopupHistory from '@/pages/PopupHistory.vue';
import PopupHistoryView from '@/pages/PopupHistoryView.vue';

const routes = [
  {
    path: '/',
    component: Home
  },

  {
    path: '/chat/:id',
    component: Chat
  },

  {
    path: '/history-preview/:id',
    component: PopupHistoryView
  },

  // {
  //   path: '/sign-in',
  //   popup: {
  //     component: PopupSignIn
  //   }
  // },
  {
    path: '/calendar',
    popup: {
      component: PopupCalendar
    }
  },
  {
    path: '/booking',
    popup: {
      component: PopupBooking
    }
  },
  {
    path: '/proofread',
    popup: {
      component: PopupProofread
    }
  },
  {
    path: '/admin',
    popup: {
      component: PopupAdmin
    }
  },
  {
    path: '/settings',
    popup: {
      component: PopupSettings
    }
  },
  {
    path: '/user-history-list/:id',
    popup: {
      component: PopupHistory
    }
  }
];

export default routes;
